<template lang="pug">
  app-dialog(v-model="$_show" :header="headerText" :confirm-text="confirmText" :confirm-disabled="isNotReady" @confirm="uploadTemplate")
        v-form(ref="addTemplateForm" v-model="valid")
           v-btn.mx-0(@click="$refs.localtemplate.click()") Выберите файл
             v-icon(right dark) attach_file
           input(id="org-upload-template-id" type="file" style="display: none" ref="localtemplate" :accept="acceptFormats" @change="changeTemplate")
           .wrap.mt-1 {{ newFile.basename }}
           app-text-field.mt-6(v-model="newFile.name" label="Новое название файла" counter="30" :rules="[rules.required]")
           app-text-field.mt-6(v-model="form.walias" label="Псевдоним" counter="30")
           app-select(v-if="sendChannels.length > 0" v-model="form.sendChannel" :items="sendChannels" label="Тип доставки" item-text="title" :rules="[rules.required]")

</template>

<script>
import { AppDialogToggable } from '@/components'
import { $_validate_rules } from '@/common/ValidateRules'
import { docService, caseService } from '@/_services'

export default {
  mixins: [AppDialogToggable, $_validate_rules],
  props: {
    template: null,
    org: null
  },
  data () {
    const defaultForm = Object.freeze({
      id: null,
      name: '',
      walias: '',
      templateFile: '',
      organization: null, 
      sendChannel: null
    })

    return {
      valid: false,
      form: Object.assign({}, defaultForm),
      defaultForm,
      sendChannels: [],
      newFile: {
        name: null,
        basename: null,
      }
    }
  },
  methods: {
    createTemplate(fileName = '') {
      if (this.$refs.addTemplateForm.validate()) {
          if(this.form.id==null){
              this.form.organization=this.org
              this.form.name=this.newFile.name
              this.form.templateFile=fileName
              this.$store.dispatch('organization/CREATE_TEMPLATE', this.form)
          } else
              this.$store.dispatch('organization/UPDATE_TEMPLATE', this.form)
      }
    },

    changeTemplate () {
      let input = document.getElementById('org-upload-template-id')
      let file = input.files[0]
      this.newFile.name = file.name
      this.newFile.basename = file.name
    },
    uploadTemplate () {
      if (this.$refs.addTemplateForm.validate()) {
          var formData = new FormData();
          var fileEl = document.getElementById('org-upload-template-id')
          formData.append("file", fileEl.files[0])
          
          docService.uploadRfiles(formData)
          .then(data => this.createTemplate(data))
      }
    },
  },
  watch: {
    $_show (value) {
      if (value) {
        let baseObj = this.template || this.defaultForm
        this.form = JSON.parse(JSON.stringify(baseObj))
      }
    },
  },
  computed: {
    isNotReady () {
      if(!this.valid) return true
      return false
    },
    confirmText() {
      return this.template!=null ? "Редактировать" : "Добавить"
    },
    headerText() {
      return this.template!=null ? "Редактировать шаблон" : "Добавить шаблон"
    },
    acceptFormats () {
      let types = [
        'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
        'application/vnd.openxmlformats-officedocument.wordprocessingml.template'
      ]
      return types.join(', ')
    },

  },
  created() {
    caseService.sendChannels()
    .then(data => {
      this.sendChannels=data
    })
  }
}
</script>

<style lang="scss" scoped>

</style>

